import { render, staticRenderFns } from "./rem.vue?vue&type=template&id=52ef545f&scoped=true"
import script from "./rem.vue?vue&type=script&lang=js"
export * from "./rem.vue?vue&type=script&lang=js"
import style0 from "./rem.vue?vue&type=style&index=0&id=52ef545f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ef545f",
  null
  
)

export default component.exports